import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import About from '../components/About'
import { useSelector } from 'react-redux'

const AboutPage = () => {
	const isPageLoading = useSelector((state) => state.pages.isLoading)
	return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
		<About />
	)
}

export default AboutPage